import { X } from "lucide-react";

const Popup = ({
  title,
  children,
  onClose,
  maxWidth = "1200px",
  height = "80vh",
  minHeight = "60vh",
}) => {
  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Modal container */}
      <div
        className="bg-white rounded-2xl flex flex-col shadow-2xl w-[95vw] max-h-[90vh] sm:w-[90vw] md:max-h-[85vh] lg:w-auto"
        style={{
          width: "95vw",
          maxWidth,
          height: "auto",
          maxHeight: "90vh",
          minHeight: "60vh",
          minWidth: "80vw"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-[#8230ff] text-white px-4 sm:px-6 py-4 flex justify-between items-center rounded-t-2xl flex-wrap gap-2">
          <h2 className="text-lg sm:text-xl font-bold break-words">{title}</h2>
          <button
            onClick={onClose}
            className="p-2 bg-white rounded-full hover:bg-gray-200 transition flex-shrink-0"
          >
            <X className="h-[20px] w-[20px] text-black" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto px-4 sm:px-6 py-4">{children}</div>
      </div>
    </div>
  );
};

export default Popup;
